import React from 'react';

const steps = [
  {
    step: 1,
    title: 'Connect your accounts',
    description:
      'Connect your POS, online store, and Meta/Google ad accounts. Read-only access. No code. No CSV uploads.',
    badge: 'UNDER 2 MINUTES',
    accent: {
      icon: 'bg-gradient-to-br from-sky-100 to-sky-50 text-sky-900 ring-sky-200/90',
      card: 'border-sky-200/70 bg-gradient-to-br from-white to-sky-50/50',
    },
  },
  {
    step: 2,
    title: 'Scan your last 30 days',
    description:
      'Kolanut compares spend vs results and flags the campaigns that are losing money.',
    badge: 'INSTANT REPORT',
    accent: {
      icon: 'bg-gradient-to-br from-violet-100 to-violet-50 text-violet-900 ring-violet-200/90',
      card: 'border-violet-200/70 bg-gradient-to-br from-white to-violet-50/40',
    },
  },
  {
    step: 3,
    title: 'Take action with confidence',
    description:
      'Get clear next steps: what to pause, what to fix, and where to reallocate budget. No auto-execution.',
    badge: 'NO RISK',
    accent: {
      icon: 'bg-gradient-to-br from-amber-100 to-amber-50 text-amber-950 ring-amber-200/90',
      card: 'border-amber-200/70 bg-gradient-to-br from-white to-amber-50/45',
    },
  },
];

const GuaranteeSection = () => {
  return (
    <section id="how-it-works" className="py-12 md:py-20 bg-gradient-to-b from-stone-50/90 via-white to-slate-50/40">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14 max-w-2xl mx-auto px-4">
          <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-black/80 mb-6">
            How it works
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-[2.125rem] font-semibold text-black tracking-tight leading-snug mb-4">
            Find wasted ad dollars in minutes
          </h2>
          <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
            Connect accounts. Scan the last 30 days. Get actions you can trust.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 lg:gap-8">
          {steps.map(({ step, title, description, badge, accent }) => (
            <div
              key={step}
              className={`group relative flex flex-col h-full min-h-[260px] rounded-3xl border p-6 md:p-7 shadow-[0_22px_60px_-28px_rgba(15,23,42,0.14)] transition-[box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:shadow-[0_28px_72px_-32px_rgba(15,23,42,0.2)] ${accent.card}`}
            >
              <div className="flex flex-col flex-1">
                <div
                  className={`flex h-12 w-12 items-center justify-center rounded-2xl shadow-[inset_0_1px_0_rgba(255,255,255,0.7)] ring-1 mb-4 shrink-0 text-base font-bold ${accent.icon}`}
                  aria-hidden
                >
                  {step}
                </div>
                <h3 className="font-semibold text-lg md:text-xl text-black mb-3 text-left">
                  {title}
                </h3>
                <p className="text-stone-600 text-base md:text-lg leading-relaxed text-left flex-1">
                  {description}
                </p>
                <div className="mt-5 pt-2">
                  <span className="inline-flex items-center rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs md:text-sm font-semibold text-emerald-800">
                    {badge}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GuaranteeSection;
